import { __rest } from "tslib";
import React, { useEffect } from 'react';
import cn from 'classnames';
import { useForm, FormProvider } from 'react-hook-form';
/**
 * Form :: Will handle validation and state of children inputs. Expects a child with type="submit"
 * @param {onSubmit} callback function for onSubmit returning all the values of the inputs in the form
 * @param {currentData} default value to prepopulate fields
 */
const Form = (_a) => {
    var { onSubmit, errors = [], mode = 'onTouched', currentData, shouldResetForm = false, children, className } = _a, props = __rest(_a, ["onSubmit", "errors", "mode", "currentData", "shouldResetForm", "children", "className"]);
    const formProps = useForm({
        defaultValues: currentData,
        mode,
    });
    useEffect(() => {
        errors.forEach(({ target, type, message } = {}) => {
            if (!target) {
                return;
            }
            formProps.setError(target, {
                type: type || 'backendError',
                message,
            });
        });
    }, [errors]);
    useEffect(() => {
        if (shouldResetForm) {
            formProps.reset(currentData);
        }
    }, [shouldResetForm]);
    if (!children) {
        return null;
    }
    const handleSubmit = (formData, event) => {
        if (!onSubmit) {
            return;
        }
        onSubmit(formData, { resetForm: formProps.reset, event });
    };
    return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; defaultValues: any; reg... Remove this comment to see the full error message
    React.createElement(FormProvider, Object.assign({}, formProps, { defaultValues: currentData }),
        React.createElement("form", Object.assign({ className: cn(className), onSubmit: formProps.handleSubmit(handleSubmit) }, props, { noValidate: true }), children)));
};
export default Form;
//# sourceMappingURL=Form.js.map